module.exports = __webpack_public_path__ + "static/media/trash.6ee5788a.png";